<!-- <h1 mat-dialog-title>Export Data</h1>
<div mat-dialog-content>
  <p>What's your favorite animal?</p>
  <mat-form-field>
    <mat-label>Favorite Animal</mat-label>
    <input matInput [(ngModel)]="data.animal">
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">No Thanks</button>
  <button mat-button [mat-dialog-close]="data.animal" cdkFocusInitial>Ok</button>
</div> -->


<form [formGroup]="exportForm">
    <h1 mat-dialog-title>Export Data</h1>
    <mat-form-field appearance="outline" class="w-100">
        <mat-label>Name</mat-label>
      <input matInput formControlName="name" placeholder="Name">
    </mat-form-field>
    <h1 mat-dialog-title>Export As</h1>
    <div *ngFor="let option of exportOptions">
        <label>
          <input type="radio" [value]="option.value" formControlName="exportOption">
          {{ option.label }}
        </label>
      </div>
      <!-- <h1 mat-dialog-title>Options</h1>
      <label>
        <input type="checkbox" formControlName="keepValueFormatting">
        Keep value formatting
      </label> -->
      <div class="mt-3" style="display: flex;justify-content: end">
        <button mat-stroked-button color="primary" class="me-2" (click)="onNoClick()">Cancel</button>
        <button mat-raised-button color="primary" type="button" (click)="onSubmit()">Export</button>
      </div>
     
  </form>